import i18n from "@/i18n";
export const WorkOrderTableHeader = [
  {
    name: "number",
    label: i18n.global.t("page.work-order.number"),
    visible: true,
  },
  {
    name: "type",
    label: i18n.global.t("page.work-order.type.text"),
    visible: true,
  },
  {
    name: "priority",
    label: i18n.global.t("page.work-order.priority.text"),
    visible: true,
  },
  {
    name: "device_name",
    label: i18n.global.t("page.work-order.device-name"),
    visible: true,
  },
  {
    name: "device_root_sn",
    label: i18n.global.t("page.work-order.device-root-sn"),
    visible: true,
  },
  {
    name: "warranty_status",
    label: i18n.global.t("page.work-order.warranty-status.text"),
    visible: false,
  },
  {
    name: "customer_contact_name",
    label: i18n.global.t("page.work-order.contact"),
    visible: true,
  },
  {
    name: "customer_contact_number",
    label: i18n.global.t("page.work-order.contact-phone"),
    visible: true,
  },
  {
    name: "status",
    label: i18n.global.t("page.work-order.status.text"),
    visible: true,
  },
  {
    name: "customer_txt",
    label: i18n.global.t("page.work-order.customer-name"),
    visible: true,
  },
  {
    name: "service_company_txt",
    label: i18n.global.t("page.service-company"),
    visible: true,
  },
  {
    name: "engineer",
    label: i18n.global.t("page.engineer"),
    visible: true,
  },
  {
    name: "created_at",
    label: i18n.global.t("page.create-time"),
    visible: true,
  },
]